export const DEFAULT_ADDRESS_ID = "00000000-0000-4000-8000-000000000000";
export const UNSET_DISPLAY_NAME_KEY = "__unsetDisplayName$$$";
